import { Component, Input } from '@angular/core';
import { TraitementDataComponent } from '../../traitement-data/traitement-data/traitement-data.component';
import { TraitementDataObsComponent } from '../../traitement-data/traitement-data-obs/traitement-data-obs.component';
import { TraitementDataModeComponent } from '../../traitement-data/traitement-data-mode/traitement-data-mode.component';
import { Patient } from '../../../models/patient';
import { TraitementDataEpapComponent } from "../../traitement-data/traitement-data-epap/traitement-data-epap.component";
import { TraitementDataAiMinMaxComponent } from "../../traitement-data/traitement-data-ai-min-max/traitement-data-ai-min-max.component";
import { TraitementDataFuites95Component } from "../../traitement-data/traitement-data-fuites-95/traitement-data-fuites-95.component";
import { TraitementDataIpap95Component } from "../../traitement-data/traitement-data-ipap-95/traitement-data-ipap-95.component";
import { TraitementDataEpap95Component } from "../../traitement-data/traitement-data-epap-95/traitement-data-epap-95.component";
import { TraitementDataEpapMinMaxComponent } from "../../traitement-data/traitement-data-epap-min-max/traitement-data-epap-min-max.component";
import { TraitementDataFuitesComponent } from "../../traitement-data/traitement-data-fuites/traitement-data-fuites.component";

@Component({
  selector: 'app-traitement-ppc-servo-ventilation-card',
  standalone: true,
  imports: [
    TraitementDataObsComponent,
    TraitementDataModeComponent,
    TraitementDataComponent,
    TraitementDataEpapComponent,
    TraitementDataAiMinMaxComponent,
    TraitementDataFuites95Component,
    TraitementDataIpap95Component,
    TraitementDataEpap95Component,
    TraitementDataEpapMinMaxComponent,
    TraitementDataFuitesComponent
  ],
  templateUrl: './traitement-ppc-servo-ventilation-card.component.html',
  styleUrl: './traitement-ppc-servo-ventilation-card.component.scss'
})
export class TraitementPpcServoVentilationCardComponent {
  @Input() patient: Patient | undefined;
}
